export default function MarqueeDivider() {
  const items = ["Create With AI", "Launch Your Product", "Sell Online", "Digital Product Academy"];
  const row = [...items, ...items, ...items];
  return (
    <div aria-hidden="true" className="overflow-hidden border-y border-[#E9DFFC] bg-[#F6F1FF] py-5">
      <div className="marquee-slow-track flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="text-lg font-extrabold uppercase tracking-[0.15em] text-transparent [-webkit-text-stroke:1px_#7C3AED] sm:text-xl">
                  {t}
                </span>
                <span className="text-[#9B5CF0]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
